export const helperFunction = {
  saveItem: function (name, value) {
    localStorage.setItem(`${name}`, JSON.stringify(value));
  },
  removeItem: function (name) {
    localStorage.removeItem(name);
  },
  encryptUserData: function (data, token) {
    if (data) {
      localStorage.setItem("userId", JSON.stringify(data?.id));
      localStorage.setItem("userData", JSON.stringify(data));
    }
    if (token) {
      localStorage.setItem("Token", JSON.stringify(token));
    }
    return true;
  },
  getUserKey: function (keys = null) {
    const userData = localStorage.getItem(keys);
    return userData;
  },
  getToken: function () {
    const userData = localStorage.getItem("Token");
    if (userData) {
      return userData;
    }
    return {};
  },
  getUserInfo: function () {
    const userData = JSON.parse(localStorage.getItem("userId"));
    if (userData) {
      return userData;
    }
    return "";
  },
  getUserData: function () {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData) {
      return userData;
    }
    return "";
  },
  handleDownload: async function (
    updateDownloadCount,
    arbitrationId,
    toast,
    dispatch,
    url,
    filename,
  ) {
    try {
      dispatch(updateDownloadCount(arbitrationId, ""));
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      toast.fire({ icon: "error", title: error });
    }
  },
  handleDownloadPdf: async function (
    countAction,
    id,
    toast,
    dispatch,
    pdfFile,
  ) {
    countAction && dispatch(countAction(id));
    const fileUrl = pdfFile;
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileUrl.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => toast.fire({ icon: "error", title: error }));
  },
  getHeaders: function () {
    const token = JSON.parse(localStorage.getItem("Token"));
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    };
    if (token) {
      headers["Authorization"] = "Bearer " + token;
      headers["access-token"] = token;
    }
    return headers;
  },
  isAuthenticated: function () {
    const rawToken = this.getToken();
    let userToken;

    try {
      if (typeof rawToken === "string") {
        if (
          rawToken === "undefined" ||
          rawToken === "{}" ||
          rawToken === "" ||
          rawToken.trim() === ""
        ) {
          userToken = null;
        } else {
          userToken = JSON.parse(rawToken);
        }
      } else if (rawToken && typeof rawToken === "object") {
        userToken = Object.keys(rawToken).length > 0 ? rawToken : null;
      } else {
        userToken = null;
      }
    } catch {
      userToken = null;
    }

    return (
      userToken &&
      userToken !== null &&
      userToken !== "undefined" &&
      userToken !== "{}" &&
      (typeof userToken !== "object" || Object.keys(userToken).length > 0)
    );
  },
  logout: function () {
    localStorage.removeItem("uToken");
    localStorage.removeItem("Token");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("userId");
    localStorage.removeItem("userData");
  },
  allowedMediaTypes: {
    images: ["jpg", "jpeg", "png", "gif", "svg", "pdf"],
    files: ["pdf"],
  },
};
